export const encyclopediaEn = {
  // Shared
  'encyclopedia.lockAria': 'Locked — unlock to read',

  // EncyclopediaPage
  'encyclopedia.page.seoTitle': 'The Encyclopedia',
  'encyclopedia.page.seoDescription':
    'Search the living grimoire of Grymwyrd — monsters, spells, species, items, locations and more.',
  'encyclopedia.page.heading': 'The Encyclopedia',
  'encyclopedia.page.subtitle': 'The living grimoire of every horror, spell, and legend in Grymwyrd.',
  'encyclopedia.page.searchPlaceholder': 'Search {plural}…',
  'encyclopedia.page.searchAria': 'Search {plural}',
  'encyclopedia.page.clearSearch': 'Clear search',
  'encyclopedia.page.systemNotLivePrefix': 'The Veil has not yet parted for',
  'encyclopedia.page.systemNotLiveSuffix':
    '. No lore bound to this rite has bled through — its grimoire waits beyond the dark.',
  'encyclopedia.page.returnToAllSystems': 'Return to all systems',
  'encyclopedia.page.settingNotLivePrefix': 'The lands of',
  'encyclopedia.page.settingNotLiveSuffix':
    ' are still being charted — its entries are not yet bound to the setting. Until the cartographers finish, nothing answers here.',
  'encyclopedia.page.returnToAllRealms': 'Return to all realms',
  'encyclopedia.page.filteringBy': 'Filtering by',
  'encyclopedia.page.filterSystem': 'system “{label}”',
  'encyclopedia.page.filterCanon': 'canon layer “{label}”',
  'encyclopedia.page.filterSetting': 'setting “{label}”',
  'encyclopedia.page.canonNote': 'Canon layer applies once entities are tagged in the API (see _docs/13). ',
  'encyclopedia.page.clear': 'Clear',
  'encyclopedia.page.hide': 'Hide',
  'encyclopedia.page.filter': 'Filter',

  // EntityCard
  'encyclopedia.entityCard.unlockAria': 'Unlock {name} (Grymwyrd content)',
  'encyclopedia.entityCard.viewAria': 'View {name} entry',

  // EntityGrid
  'encyclopedia.grid.paginationAria': 'Pagination ({position})',
  'encyclopedia.grid.prev': 'Prev',
  'encyclopedia.grid.next': 'Next',
  'encyclopedia.grid.pageOf': 'Page {page} of {totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} results',
  'encyclopedia.grid.scrying': 'Scrying the archives…',
  'encyclopedia.grid.count': '{total} {plural}',
  'encyclopedia.grid.sortDescAria': 'Sort descending',
  'encyclopedia.grid.sortAscAria': 'Sort ascending',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': 'View mode',
  'encyclopedia.grid.gridViewAria': 'Grid view',
  'encyclopedia.grid.listViewAria': 'List view',
  'encyclopedia.grid.jumpToLetterAria': 'Jump to letter',
  'encyclopedia.grid.all': 'All',
  'encyclopedia.grid.letterSymbolAria': 'Entries starting with a number or symbol',
  'encyclopedia.grid.letterAria': 'Entries starting with {letter}',
  'encyclopedia.grid.emptyTitle': 'The Archive is Silent',
  'encyclopedia.grid.emptyForLetter': 'No {plural} bear a name beginning with “{letter}.”',
  'encyclopedia.grid.emptyAll': 'No {plural} answer your call.',
  'encyclopedia.grid.turningPages': 'Turning pages…',

  // EntityImage
  'encyclopedia.entityImage.noArtworkAria': '{label} (no artwork)',
  'encyclopedia.entityImage.noVision': 'No Vision',
  'encyclopedia.entityImage.zoomAria': 'Zoom in on artwork for {label}',
  'encyclopedia.entityImage.zoomClose': 'Close image viewer',

  // FacetSidebar
  'encyclopedia.facets.all': 'All',
  'encyclopedia.facets.soon': 'Soon',
  'encyclopedia.facets.navAria': 'Entity type filters',
  'encyclopedia.facets.clearAll': 'Clear all filters',
  'encyclopedia.facets.lorebook': 'Lorebook',
  'encyclopedia.facets.gameSystem': 'Game System',
  'encyclopedia.facets.canonLayer': 'Canon Layer',
  'encyclopedia.facets.setting': 'Setting',

  // GlobalSearch
  'encyclopedia.globalSearch.title': 'Search the Veil',
  'encyclopedia.globalSearch.placeholder': 'Search monsters, spells, locations, lore…',
  'encyclopedia.globalSearch.queryAria': 'Search query',
  'encyclopedia.globalSearch.loading': 'Scrying…',
  'encyclopedia.globalSearch.empty': 'Nothing stirs in the dark for “{q}”.',

  // LockedContent — LockBadge
  'encyclopedia.lockBadge.title': 'Grymwyrd content — unlock to read',
  'encyclopedia.lockBadge.label': 'Locked',
  // LockedContent — LockedGate
  'encyclopedia.lockedGate.regionAria': 'Locked content',
  'encyclopedia.lockedGate.defaultTitle': 'This lore is sealed',
  'encyclopedia.lockedGate.body':
    "Grymwyrd's own bestiary, spells, and legends are bound to the Grymwyrd Cataclysm. The open SRD canon stays free — but to walk the eternal twilight itself, claim the book.",
  'encyclopedia.lockedGate.unlockCta': 'Unlock Grymwyrd',
  'encyclopedia.lockedGate.signInCta': 'Already a backer? Sign in',
  'encyclopedia.lockedGate.backerNote':
    'Backers who pledged for Grymwyrd already own this — sign in to unlock it on your account.',

  // TableView
  'encyclopedia.table.rollToastTitle': '{name} — rolled {total}',
  'encyclopedia.table.noRowMatched': 'No row matched {total}.',
  'encyclopedia.table.loading': 'Unfurling the table…',
  'encyclopedia.table.error': 'This table could not be drawn.',
  'encyclopedia.table.roll': 'Roll {formula}',
  'encyclopedia.table.lastRoll': 'Last roll: {value}',
  'encyclopedia.table.noMatchingRow': ' · no matching row',

  // EntityDetailPage
  'encyclopedia.detail.entryFallback': 'Entry',
  'encyclopedia.detail.addedToCampaign': 'Added to your campaign.',
  'encyclopedia.detail.addError': 'Could not reach the campaign vault. Try again later.',
  'encyclopedia.detail.unknownType': 'Unknown entry type.',
  'encyclopedia.detail.seoDescription': '{name} — a {label} in the Grymwyrd Encyclopedia.',
  'encyclopedia.detail.breadcrumbAria': 'Breadcrumb',
  'encyclopedia.detail.breadcrumbRoot': 'Encyclopedia',
  'encyclopedia.detail.sourceVersionAria': 'Source version',
  'encyclopedia.detail.versionConsolidated': 'Consolidated',
  'encyclopedia.detail.versionBook': 'Specific Book',
  'encyclopedia.detail.removeBookmarkAria': 'Remove bookmark',
  'encyclopedia.detail.addBookmarkAria': 'Add bookmark',
  'encyclopedia.detail.bookmarked': 'Bookmarked',
  'encyclopedia.detail.bookmark': 'Bookmark',
  'encyclopedia.detail.addToCampaign': 'Add to Campaign',
  'encyclopedia.detail.sealedTitle': '{name} is sealed',
  'encyclopedia.detail.statsSealedTitle': "{name}'s stats are sealed",
  'encyclopedia.detail.bookVariantNote':
    'Showing the consolidated record; per-book variant text will appear here once book editions are linked.',
  'encyclopedia.detail.tablistAria': 'Entry sections',
  'encyclopedia.detail.tab.lore': 'Lore',
  'encyclopedia.detail.tab.stats': 'Stats',
  'encyclopedia.detail.tab.gallery': 'Gallery',
  'encyclopedia.detail.tab.relations': 'Relations',
  'encyclopedia.detail.tab.discussions': 'Discussions',
  'encyclopedia.detail.tab.claims': 'Player Claims',
  'encyclopedia.detail.loading': 'Awakening the entry…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': 'Unearthing the lore…',
  'encyclopedia.lore.empty': 'The histories of this entry remain unwritten.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': 'Reading the runes…',
  'encyclopedia.stats.empty': 'No mechanics are recorded for this entry.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': 'Developing the visions…',
  'encyclopedia.gallery.emptyTitle': 'No Visions Yet',
  'encyclopedia.gallery.emptyBody': 'No artwork has been bound to this entry. Contribute one in the Vault.',
  'encyclopedia.gallery.artworkAlt': 'Entity artwork',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': 'Gathering whispers…',
  'encyclopedia.discussions.emptyTitle': 'Silence in the Halls',
  'encyclopedia.discussions.emptyBody': 'Be the first to discuss this entry with fellow wanderers.',
  'encyclopedia.discussions.startCta': 'Start a Discussion',
  'encyclopedia.discussions.untitledThread': 'Untitled thread',
  'encyclopedia.discussions.byAuthor': 'by {author}',
  'encyclopedia.discussions.replyCount': '{count} replies',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': 'Your claim has been recorded for review.',
  'encyclopedia.claims.recordError': 'The scribes could not record your claim. Try again later.',
  'encyclopedia.claims.loading': 'Consulting the canon…',
  'encyclopedia.claims.emptyTitle': 'No Player Claims Yet',
  'encyclopedia.claims.emptyBody': 'No wanderer has yet woven their legend into this entry.',
  'encyclopedia.claims.claimCta': 'Claim this',
  'encyclopedia.claims.signInCta': 'Sign in to stake a claim',
  'encyclopedia.claims.untitledClaim': 'Untitled claim',
  'encyclopedia.claims.byAuthor': 'by {author}',
  'encyclopedia.claims.addCta': 'Add your claim',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': 'This Entry',
  'encyclopedia.relations.relationLabel': 'Relation {index}',
  'encyclopedia.relations.loading': 'Tracing the threads of fate…',
  'encyclopedia.relations.hint': 'Click a linked entry to travel to it.',
  'encyclopedia.relations.empty': 'No relations have been recorded for this entry yet.',

  // Lore tab: the consolidated article and the Specific book view
  'encyclopedia.glance.heading': 'At a glance',
  'encyclopedia.glance.kind': 'Kind',
  'encyclopedia.glance.keeper': 'Kept by',
  'encyclopedia.glance.hours': 'Hours',
  'encyclopedia.glance.gates': 'Gates',
  'encyclopedia.glance.ruler': 'Ruled by',
  'encyclopedia.glance.floors': 'Floors',
  'encyclopedia.glance.districts': 'Quarters',
  'encyclopedia.glance.buildings': 'Buildings',
  'encyclopedia.glance.busy': 'Busiest hours',
  'encyclopedia.glance.landmarks': 'Landmarks',
  'encyclopedia.glance.trees': 'Trees',
  'encyclopedia.glance.regulars': 'Regulars',
  'encyclopedia.glance.residents': 'Residents',
  'encyclopedia.glance.wares': 'Wares',
  'encyclopedia.glance.occupation': 'Occupation',
  'encyclopedia.glance.people': 'People',
  'encyclopedia.glance.fullName': 'Full name',
  'encyclopedia.glance.age': 'Age',
  'encyclopedia.glance.pronouns': 'Pronouns',
  'encyclopedia.glance.home': 'Home',
  'encyclopedia.glance.haunts': 'Often found at',
  'encyclopedia.glance.feasts': 'Feasts kept',
  'encyclopedia.glance.asksHelpWith': 'Asks for help with',
  'encyclopedia.book.from': 'From {books}',
  'encyclopedia.book.sealedIn': "The book's own text for this entry is in the book",
  'encyclopedia.book.none': 'This entry does not appear in a book yet.',
} as const
